/**
 * The REST API base URL, and the ONE place `import.meta` is touched on the way
 * to it.
 *
 * `import.meta` is Vite/ESM syntax. Jest runs CommonJS, where it is not merely
 * undefined — it is a PARSE ERROR, so no runtime guard can rescue a module that
 * mentions it. That is why three of this repo's test suites fail before they run
 * a single assertion: they import a screen, which imports a service, which reads
 * `import.meta.env` at module scope, and the file cannot even be transformed.
 *
 * Isolating the read into a leaf module with no other dependencies means a test
 * can `jest.mock('./apiBase')` and the real file is never loaded, never parsed,
 * never a problem. The service under test stays honest; the bundler stays happy.
 *
 * (`.env.production` sets VITE_API_BASE_URL *with* the /api suffix; local dev
 * only sets VITE_API_URL *without* it. Deriving the suffix here is why local dev
 * doesn't silently fall through every `if (!API_BASE)` guard in the codebase.)
 */
export const API_BASE: string = (
  import.meta.env.VITE_API_BASE_URL ||
  (import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}/api` : '')
).replace(/\/$/, '');

export default API_BASE;
